export default {
    init() {
        this.dukItemToggle();
        this.dukForm();
    },

    dukItemToggle(){
        $('.duk--item').on('click',function(){
            let dukAnswer = $(this).find('.duk--item-text');
            if(!$(this).hasClass('active')){
                $('.duk--item').removeClass('active');
                $('.duk--item-text').slideUp(300);
                dukAnswer.slideDown(300);
                $(this).addClass('active');
            } else{
                $(this).removeClass('active');
                dukAnswer.slideUp(300);
            }
        });
    },

    dukForm(){
        function validateEmail(elementValue1) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(elementValue1)
        }

        $(document).on('submit', '.duk--form', function (e) {
            e.preventDefault();
            let loader = $('.duk--form .loader-holder');
            let checkMark = $('.duk--form .form-checkbox');
            let errorMsg = $('.duk--form .error-message');
            let successMsg = $('.duk--form .success-message');
            errorMsg.hide();
            successMsg.hide();
            loader.show();
            let validation = true;
            let contactEmail = $('.duk--form .form-email');


            $(".form-input", this).each(function () {
                let element = $(this);
                if (element.val() === "") {
                    element.closest('.form-item').addClass('input-invalid');
                    validation = false;
                } else {
                    element.closest('.form-item').removeClass('input-invalid');
                }
            });


            if ($('.duk--form .rules').is(":checked")) {
                checkMark.removeClass('input-invalid');
            } else {
                checkMark.addClass('input-invalid');
                validation = false;
            }

            let value = contactEmail.val();
            let valid = validateEmail(value);
            if (!valid) {
                contactEmail.closest('.form-item').addClass('input-invalid');
                validation = false;
            } else {
                contactEmail.closest('.form-item').removeClass('input-invalid');
            }

            if (validation == true) {
                successMsg.slideDown(300);
            } else {
                errorMsg.slideDown(300);
            }

            setTimeout(function () {
                loader.fadeOut(300);
            }, 1000);
        });
    }

}